import { jsxs as _jsxs } from "react/jsx-runtime";
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
var NoDescription = function (_a) {
    var _b = _a.transactionType, transactionType = _b === void 0 ? 'PURCHASE' : _b, _c = _a.hasError, hasError = _c === void 0 ? false : _c, _d = _a.errorMessage, errorMessage = _d === void 0 ? '' : _d, description = _a.description;
    var noDescriptionMessage = hasError ? errorMessage : transactionType;
    var isMobile = useDeviceWidth();
    return (_jsxs(StyledText, { size: isMobile ? 'regular' : 'root', color: hasError ? colors.terracotta : '', children: [noDescriptionMessage, description] }));
};
export default NoDescription;
//# sourceMappingURL=index.js.map